export default __webpack_public_path__ + "static/media/help--hero.7ab3bd74.png";